import type { APIClient } from '@src/shared/api';
import settings from '@src/shared/config';

import { useMutation } from '@src/shared/query';

const changeLanguageUrl = `${settings.AUTH.JWT.AUTH_DOMAIN}/api/v1/auth/language/change/`;

export type LanguageChangePayload = {
  language: string;
};

type LanguageChangeResponse = {
  detail: string;
  language: string;
};

export function useLanguageChange() {
  return useMutation<LanguageChangeResponse, Error, LanguageChangePayload>({
    mutationKey: ['auth', 'language-change'],
    mutateFn: ({ apiClient, ...payload }: { apiClient: APIClient } & Record<string, unknown>) => {
      return apiClient.request({
        url: changeLanguageUrl,
        method: 'POST',
        payload,
      }) as Promise<LanguageChangeResponse>;
    },
  });
}
